// Module
var code = "<template> <require from=\"./toolbar.scss\"></require> <slot></slot> </template> ";
// Exports
module.exports = code;